/* eslint-disable require-jsdoc */
import * as config from '../../config.json';
import {checkMethod} from '../../utils/validate';
const debug = config.debug;

function getFetchOpts(method, auth) {
  const httpMethod = checkMethod(method);
  let myHeaders = {};
  if (httpMethod == 'method issue') {
    return httpMethod;
  }
  if (auth) {
    myHeaders = {
      Authorization: config.apiKey,
    };
  }
  return {
    method: httpMethod,
    headers: myHeaders,
  };
}
async function getFetchResults(url, opts) {
  const response = await fetch(url, opts);
  return await response.json();
}

function status(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(new Error(response.statusText));
  }
}

function json(response) {
  return response.json();
}
export {getFetchOpts, getFetchResults, status, json};
